import styled from "styled-components";

export const HyperLinkSpan = styled.span`
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  text-decoration: underline;
  color: #007bff;
`;
